<div class="modal-header">
  <h4 class="modal-title">{{ (title | translate) | titlecase }}</h4>
  <button class="btn-close" type="button" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  @if (isFormReady) {
    <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit()" novalidate="novalidate">
      <div class="mb-4"><label class="form-label fw-semibold">{{ 'MODALS.REFERENCE_RELATIONSHIPS.RELATIONSHIP_NAME' | translate }}</label>
      @for (lang of languages; track lang) {
        @if (lang.id === 'en' || additionalLanguages.length > 0) {
          <div class="mb-3"><input class="form-control" type="text" [formControlName]="lang.id" [placeholder]="additionalLanguages.length > 0 ? ('MODALS.REFERENCE_RELATIONSHIPS.ENTER_LANGUAGE_NAME' | translate : { language: lang.label }) : ('MODALS.REFERENCE_RELATIONSHIPS.ENTER_NAME' | translate)" />@if (additionalLanguages.length > 0) {
            <small class="text-muted">{{ lang.label }}</small>
          }</div>
        }
      }
    </div>
    <div class="mb-4"><label class="form-label fw-semibold">{{ 'MODALS.REFERENCE_RELATIONSHIPS.QUESTION_SET' | translate }}<small class="text-muted ms-2">{{ 'MODALS.REFERENCE_RELATIONSHIPS.OPTIONAL' | translate }}</small></label><select class="form-control form-select" formControlName="question_set_id">
    <option value="">{{ 'MODALS.REFERENCE_RELATIONSHIPS.SELECT_QUESTION_SET' | translate }}</option>
    @for (qs of questionSets; track qs) {
      <option [value]="qs.id">{{ qs.title }}</option>
    }
  </select>@if (questionSets.length === 0) {
  <small class="text-muted">{{ 'MODALS.REFERENCE_RELATIONSHIPS.NO_QUESTION_SETS' | translate }}</small>
  }@if (questionSets.length > 0) {
  <small class="text-muted">{{ 'MODALS.REFERENCE_RELATIONSHIPS.QUESTION_SET_HELP' | translate }}</small>
}</div>
<div class="mb-4">
  <div class="form-check"><input class="form-check-input" id="preventPersonalEmails" type="checkbox" formControlName="prevent_personal_emails" /><label class="form-check-label" for="preventPersonalEmails">{{ 'MODALS.REFERENCE_RELATIONSHIPS.PREVENT_PERSONAL_EMAILS' | translate }}</label></div>
</div>
@if (title === 'MODALS.REFERENCE_RELATIONSHIPS.EDIT_TITLE') {
  <div class="alert v-alert v-alert-primary mt-3"><strong>{{ 'MODALS.REFERENCE_RELATIONSHIPS.NOTE_LABEL' | translate }} </strong>{{ 'MODALS.REFERENCE_RELATIONSHIPS.EDIT_NOTE' | translate }}</div>
}
</form>
}

@if (!isFormReady) {
  <div class="text-center py-4">
    <div class="spinner-border v-text-primary" role="status"><span class="visually-hidden">{{ 'MODALS.REFERENCE_RELATIONSHIPS.LOADING' | translate }}</span></div>
  </div>
}
</div>

<div class="modal-footer"><button class="btn w-25 btn-dark ms-0" type="button" (click)="closeModal()" [disabled]="isButtonsDisabled">{{ 'BUTTONS.CANCEL' | translate }}</button><button class="btn w-25 v-btn v-btn-primary" type="submit" (click)="onSubmit()" [disabled]="entry?.invalid || isButtonsDisabled">{{ submitKey | translate }}</button></div>
